import React from 'react';
import { useTranslation } from '../i18n';

const QUESTIONS = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'] as const;

export const FaqPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="faq-page">
      <h2>{t('faq.title')}</h2>

      {QUESTIONS.map((key) => (
        <section key={key} className="faq-item">
          <h3>{t(`faq.${key}.title`)}</h3>
          <p>{t(`faq.${key}.text`)}</p>
        </section>
      ))}
    </div>
  );
};
